import { translate } from '@thoughtspot/i18n';
import { isEqual } from 'lodash';
import { useEffect, useRef, useState } from 'react';
export const useDocumentTitle = ({ companyTitle, title: initialTitle, customRouteMatches: initialRoutes, }) => {
    const originalTitleRef = useRef(null);
    const [documentTitle, setDocumentTitle] = useState(() => {
        var _a;
        const routeTitleKey = (_a = initialRoutes === null || initialRoutes === void 0 ? void 0 : initialRoutes[0]) === null || _a === void 0 ? void 0 : _a.title;
        const routeTitle = routeTitleKey
            ? translate(routeTitleKey)
            : undefined;
        return {
            companyTitle,
            pageTitle: initialTitle !== null && initialTitle !== void 0 ? initialTitle : routeTitle,
            routes: initialRoutes,
        };
    });
    const updatePageTitle = (newTitle) => {
        if (!isEqual(documentTitle.pageTitle, newTitle)) {
            setDocumentTitle(prev => ({
                ...prev,
                pageTitle: newTitle,
            }));
        }
    };
    const updateCustomRouteMatches = (newRoutes) => {
        if (!isEqual(documentTitle.routes, newRoutes)) {
            setDocumentTitle(prev => ({
                ...prev,
                routes: newRoutes,
            }));
        }
    };
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        if (originalTitleRef.current === null) {
            originalTitleRef.current = document.title;
        }
        const routeTitleKey = (_b = (_a = documentTitle.routes) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.title;
        const derivedRouteTitle = routeTitleKey
            ? translate(routeTitleKey)
            : undefined;
        const finalPageTitle = (_c = documentTitle.pageTitle) !== null && _c !== void 0 ? _c : derivedRouteTitle;
        const resolvedDocumentTitle = finalPageTitle
            ? translate('DYNAMIC_PAGE_TITLE', {
                currentPage: finalPageTitle,
                companyTitle: documentTitle.companyTitle,
            })
            : (_e = (_d = documentTitle.companyTitle) !== null && _d !== void 0 ? _d : originalTitleRef.current) !== null && _e !== void 0 ? _e : '';
        if (document.title !== resolvedDocumentTitle) {
            document.title = resolvedDocumentTitle;
        }
        return () => {
            if (originalTitleRef.current !== null &&
                document.title !== originalTitleRef.current) {
                document.title = originalTitleRef.current;
            }
        };
    }, [
        documentTitle.pageTitle,
        documentTitle.routes,
        documentTitle.companyTitle,
    ]);
    return {
        documentTitle,
        setDocumentTitle: updatePageTitle,
        setCustomRouteMatches: updateCustomRouteMatches,
    };
};
//# sourceMappingURL=use-document-title-hook.js.map